import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import MessageInput from './messageInput';
import { updateUserSettings } from 'actions/connect';
import { submitMessage } from 'actions';
import { deleteMessage } from 'actions';
import { clearMessages } from 'actions';
import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';
const {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton
} = ShareButtons;
const {
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  PinterestShareCount,
} = ShareCounts;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
const LinkedinIcon = generateShareIcon('linkedin');
const PinterestIcon = generateShareIcon('pinterest');
const VKIcon = generateShareIcon('vk');

import Message from './message';

class ChatArea extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMyMessage = this.handleMyMessage.bind(this);

    this.updateHeight = this.updateHeight.bind(this);

    this.socket = this.props.socket;
  }

  handleInputChange(event) {
  	this.setState({ body: event.target.value });
  }

  handleMyMessage(body) {
  	if (body != '') {
  		var chat_window = $(this.refs['outer-panel-body']);
  		var scroll_height = chat_window[0].scrollHeight;

      this.props.onSend({
        creator : {
          avatar : this.props.user.avatar? this.props.user.avatar : 'https://hailtrace.atlassian.net/secure/useravatar?avatarId=10349',
          screen_name : this.props.user.screen_name,
          admin : false
        },
        body,
      });
	  }
  }

  updateHeight() {
    var chatWindow = $(ReactDom.findDOMNode(this.refs['outer-panel-body']));
    var input = $(ReactDom.findDOMNode(this.refs.focusedInput));
    var chatArea = $(ReactDom.findDOMNode(this.refs.chatArea));
    chatWindow.height(chatArea.outerHeight() - input.outerHeight() - 30)
  }

  componentDidMount() {
  	this.refs.focusedInput.focus();

    $(window).resize(this.updateHeight);
    this.updateHeight();

    // Set scroll bar to the bottom
    var chat_window = $(this.refs['outer-panel-body']);
    chat_window.scrollTop(chat_window[0].scrollHeight)

    // if (!this.props.user.settings) {

    // }
  }

  componentDidUpdate(prevProps, prevState) {
  	this.refs.focusedInput.focus();
    this.updateHeight();

    // Keep scroll bar at the bottom if it was already at the bottom
    var chat_window = $(this.refs['outer-panel-body']);
    var message_box = $('.message-box');
    // var num1 = parseInt(chat_window[0].scrollHeight - chat_window.innerHeight())
    // var num2 = parseInt(chat_window.scrollTop() + message_box.innerHeight())

		// if (num1 === num2) {
			chat_window.scrollTop(chat_window[0].scrollHeight)
		// }
  }

  render() {
    var shareUrl = "https://hailtrace.com/app/live-weather-center";
    var title = "Hailtrace - Live Weather Center"
    return (
    	<div style={{
        top: "0px",

      }} ref="chatArea" className={this.props.className} >
	    	<div
	    		ref="outer-panel-body"
	    		className="panel-body group-chat-panel">
					<div
						className="inner-panel-body">
              <div style={{
                width : "90%",
                margin: "0 auto 50px auto"
              }}>
                {(()=>{
                  if(this.props.liveWeatherCenter.status.enabled)
                    return <div className="alert alert-success"><h2>We are Live!</h2></div>
                  else
                    return <div className="alert alert-default"><h2>We are Away...come back soon!</h2></div>
                })()}
                <div className="alert alert-info">
                <h3>Join the Conversation!</h3>
                <p>Our meteorologists will be available here to answer your questions.</p>
                </div>
              </div>
		  				{this.props.liveWeatherCenter.messages.map((message, index) => {
		  					return (
		  						<div className="message-box" key={index}>
			  						<Message
			  							message={message}
			  							onDelete={this.props.onDelete}
			  							/>
		  						</div>
	  						)}
		  				)}
              <div className="row well mb-none" style={{height: "42px",padding:"5px 19px", marginBottom:"0px",curser:"pointer"}}>
                <div className="col-xs-1 col-xs-offset-9 mb-none">
                  <FacebookShareButton
                    url={shareUrl}
                    title={title}
                    className="Demo__some-network__share-button">
                    <FacebookIcon
                      size={32}
                      round />
                  </FacebookShareButton>
                </div>

                <div className="col-xs-1">
                  <TwitterShareButton
                    url={shareUrl}
                    title={title}
                    className="Demo__some-network__share-button">
                    <TwitterIcon
                      size={32}
                      round />
                  </TwitterShareButton>

                  <div className="Demo__some-network__share-count">
                    &nbsp;
                  </div>
                </div>

                <div className="col-xs-1">
                  <GooglePlusShareButton
                    url={shareUrl}
                    className="Demo__some-network__share-button">
                    <GooglePlusIcon
                      size={32}
                      round />
                  </GooglePlusShareButton>
                </div>
              </div>
					</div>
				</div>
				<MessageInput
					ref="focusedInput"
					onEnter={this.handleMyMessage}/>
			</div>
    );
  }
}

function mapStateToProps({liveWeatherCenter, connection}) {
	return {
		user : connection.user,
		liveWeatherCenter,
    connection
	}
}

export default connect(mapStateToProps)(ChatArea)



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/chat/chat_area.js